import servise from '@/router/axios'
export const updateCheckedLive = (params) => {
  return servise({
    url: '/checked/live',
    method: 'get',
    params
  })
}

export const setWebCpsLive = (data) => {
  return servise({
    url: '/webCpsLive/set',
    method: 'post',
    data
  })
}
export const setWebCpsLiveAdStatus = (data) => {
  return servise({
    url: '/webCpsLive/advertisingStatus',
    method: 'post',
    data
  })
}

// 直播转链接接口
export const createLiveLink = (data) => {
  return servise({
    url: '/live/link',
    method: 'post',
    data
  })
}

// 保存直播链接信息
export const saveLiveLink = (data) => {
  return servise({
    url: '/webCpsLive/saveLink',
    method: 'post',
    data
  })
}
